import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiHttpService } from 'src/app/Service/api.http.service';
import { APIEndPoints } from 'src/app/utils/api-endpoint';

@Injectable({
  providedIn: 'root',
})
export class MyProfileService {
  myProfileInfo;
  userSelectedPlan;

  additionalmembersCost: number;
  aditionalStorageCost: number;
  additionalmemberschk: any;
  additionalstoragechk: any;
  additionalmembers: number;
  numberOfMembers: number;

  constructor(private _apiService: ApiHttpService) {}

  GetProfile(forceRefresh = false) {
    if (this.myProfileInfo && !forceRefresh) return of(this.myProfileInfo);
    return this._apiService.get(APIEndPoints.Manage + '/Profile').pipe(
      tap(({ data }) => {
        this.myProfileInfo = data;
        return data;
      })
    );
  }
  GetProfileFC(id,familyId,forceRefresh=false){
    if (this.myProfileInfo && !forceRefresh) return of(this.myProfileInfo);
    return this._apiService.get(APIEndPoints.Professional+`/UserProfile/${id}/${familyId}`).pipe(
      tap(({ data }) => {
        this.myProfileInfo = data;
        return data;
      })
    );
  }
  UpdateProfile(data) {
    return this._apiService
      .post(`${APIEndPoints.Manage}/UpdateProfile`, data)
      .pipe();
  }
  DeleteEmergencyContact(id) {
    return this._apiService
      .delete(`${APIEndPoints.Manage}/EmergencyContact/` + `${id}`)
      .pipe();
  }
  AddEmergencyContact(data) {
    return this._apiService
      .post(`${APIEndPoints.Manage}/EmergencyContact`, data)
      .pipe();
  }

  ReferUser(data) {
    return this._apiService
      .post(`${APIEndPoints.User}/referUser`, data)
      .pipe();
  }
  GetReferredData(data) {
    return this._apiService
      .post(`${APIEndPoints.User}/GetReferredData`, data)
      .pipe();
  }

  SendInviteToProfessional(data) {
    return this._apiService
      .post(`${APIEndPoints.Professional}/UserToProfessionalInvite`, data)
      .pipe();
  }

  UpdateEmergencyContact(data) {
    return this._apiService
      .put(`${APIEndPoints.Manage}/EmergencyContact/` + `${data.id}`, data)
      .pipe();
  }
  DeleteConfidante(id) {
    return this._apiService
      .delete(`${APIEndPoints.Manage}/Confidante/` + `${id}`)
      .pipe();
  }
  AddConfidante(data) {
    return this._apiService
      .post(`${APIEndPoints.Manage}/Confidante`, data)
      .pipe();
  }
  UpdateConfidante(data) {
    return this._apiService
      .put(`${APIEndPoints.Manage}/Confidante/` + `${data.id}`, data)
      .pipe();
  }
  ChangeFamilyOwner(data) {
    return this._apiService
      .post(`${APIEndPoints.Manage}/ChangeFamilyOwner/`, data)
      .pipe();
  }
  UpdatePreferences(data) {
    return this._apiService
      .post(`${APIEndPoints.Manage}/UpdatePreferences/`, data)
      .pipe();
  }
  UpdatePassword(data) {
    return this._apiService
      .post(`${APIEndPoints.Manage}/UpdatePassword/`, data)
      .pipe();
  }
  UpdateSubscription(data) {
    return this._apiService
      .post(`${APIEndPoints.Manage}/UpdateSubscription/`, data)
      .pipe();
  }
  UpdateAddOns(data) {
    return this._apiService
      .post(`${APIEndPoints.Manage}/UpdateAddOns/`, data)
      .pipe();
  }
  CancelSubscription(data) {
    return this._apiService
      .post(`${APIEndPoints.Manage}/CancelSubscription/`, data)
      .pipe();
  }

  CreateManageSubscription(data) {
    return this._apiService
      .post(`${APIEndPoints.Subscription}/createSubscription/`, data)
      .pipe();
  }
  GetManageSubscription(email) {
    return this._apiService
      .get(`${APIEndPoints.Subscription}/GetSubscription/` + `${email}`)
      .pipe();
  }
  CancelManageSubscription(data) {
    return this._apiService
      .post(`${APIEndPoints.Subscription}/CancelSubscription/`, data)
      .pipe();
  }

  UpdateFamilyMember(data) {
    return this._apiService
      .post(`${APIEndPoints.Manage}/UpdateFamilyMember/`, data)
      .pipe();
  }
  
  GetPciSubscriptionToken(data){
    return this._apiService.post(`${APIEndPoints.PciSubscription}/GetPciSubscriptionToken`,data)
  }
  
  SavePciTransactions(data){
    return this._apiService.post(`${APIEndPoints.PciSubscription}/SavePciTransactions`,data)
  }
  SavePciSubscription(data){
    return this._apiService.post(`${APIEndPoints.PciSubscription}/SavePciSubscription`,data)
  }

  GetTransactions(){
    return this._apiService.get(`${APIEndPoints.PciSubscription}/GetTransactions`);
  }
  GetTransactionsByID(){
    return this._apiService.get(`${APIEndPoints.PciSubscription}/GetTransactionsByID`);
  }

  TPAUpdateSubscription(data){
    return this._apiService
      .post(`${APIEndPoints.Professional}/TPAUpdateSubscription/`, data)
      .pipe();
  }
  TPASavePciTransaction(data){
    return this._apiService
    .post(`${APIEndPoints.Professional}/TPASavePciTransaction/`, data)
    .pipe();
  }
  TPACreateSubscription(data){
    return this._apiService
    .post(`${APIEndPoints.Professional}/TPACreateSubscription/`, data)
    .pipe();
  }
  TPASavePciSubscription(data){
    return this._apiService
    .post(`${APIEndPoints.Professional}/TPASavePciSubscription/`, data)
    .pipe();
  }
}
